<p-toast></p-toast>

<p-sidebar [(visible)]="showTransactionsSidebar"
           position="right"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'60em'}">
    <ng-template pTemplate="header">Payout Transaction: {{payoutTransaction.Id}}</ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>
    <!--Menu-->

    <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

    <div *ngIf="!loading" class="transaction-body">
        <p-scrollPanel [style]="{width:'100%', height: '100%'}"
                       [styleClass]="'app-scrollpanel'">

            <div class="transaction-info-body" *ngIf="activeTab===transactionDetailsTab.PayoutTransaction">

                <div class="transaction-info-label-group">Payout Transaction Info</div>
                <div class="flex transaction-info-block">
                    <div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Id:
                            </div>
                            <div class="od-value">
                                {{payoutTransaction.Id}}
                            </div>
                        </div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Created At:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                {{payoutTransaction.CreatedAt  | date:'short'}}
                            </div>
                        </div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Processed At:
                            </div>
                            <div class="od-value">
                                {{payoutTransaction.ProcessedAt | date:'short'}}
                            </div>
                        </div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Paid At:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                {{payoutTransaction.PaidAt | date:'short'}}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Amount:
                            </div>
                            <div class="od-value">
                                {{payoutTransaction.Amount}}
                            </div>
                        </div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Cellphone:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                {{payoutTransaction.Cellphone}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="transaction-info-label-group">Driver Info</div>
                <div class="flex transaction-info-block">
                    <div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                Id:
                            </div>
                            <div class="od-value">
                                <span class="transaction-value-link"
                                      (click)="handleShowDriverInfo()">{{payoutTransaction.RiderId}}</span>
                            </div>
                        </div>
                        <div class="flex">
                            <div class="transaction-info-item-label od-name">
                                &nbsp;
                            </div>
                            <div class="transaction-info-item-value od-value">
                                &nbsp;
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex transaction-info-item">
                            <div class="transaction-info-item-label od-name">
                                First Name:
                            </div>
                            <div class="od-value">
                                {{payoutTransaction.FirstName}}
                            </div>
                        </div>
                        <div class="flex">
                            <div class="transaction-info-item-label od-name">
                                Last Name:
                            </div>
                            <div class="transaction-info-item-value od-value">
                                {{payoutTransaction.LastName}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="transaction-info-label-group">Payout Transaction Details</div>
                <div class="flex transaction-info-block">
                    <div>
                        <div class="flex payout-column-edit">
                            <div class="transaction-info-item-label od-name">
                                Control Number:
                            </div>
                            <div class="transaction-info-item-value od-value" *ngIf="!showEditFields">
                                {{payoutTransaction.ControlNumber}}
                            </div>
                            <div class="transaction-info-item-value od-value" *ngIf="showEditFields">
                                <div><input type="text" pInputText
                                            [style]="{'width':'350px'}"
                                            [(ngModel)]="payoutTransaction.ControlNumber"
                                            placeholder="Control Number"></div>
                            </div>
                        </div>
                        <div class="flex payout-column-edit">
                            <div class="transaction-info-item-label od-name">
                                Branch Code:
                            </div>
                            <div class="transaction-info-item-value od-value" *ngIf="!showEditFields">
                                {{payoutTransaction.BranchCode}}
                            </div>
                            <div class="transaction-info-item-value od-value" *ngIf="showEditFields">
                                <div><input type="text" pInputText
                                            [style]="{'width':'350px'}"
                                            [(ngModel)]="payoutTransaction.BranchCode"
                                            placeholder="Branch Code"></div>
                            </div>
                        </div>
                        <div class="flex payout-column-edit">
                            <div class="transaction-info-item-label od-name">
                                Status:
                            </div>
                            <div class="transaction-info-item-value od-value status-active"
                                 [ngStyle]="getStatusStyles(payoutTransaction.Status)"
                                 *ngIf="!showEditFields">
                                {{getStatusName(payoutTransaction.Status) }}
                            </div>
                            <div class="transaction-info-item-value od-value" *ngIf="showEditFields">
                                <div>
                                    <p-dropdown placeholder="Select"
                                                 [options]="serviceTypes"
                                                 optionLabel="label"
                                                 optionValue="value"
                                                 [style]="{'width':'350px'}"
                                                 [showClear]="true"
                                                 [(ngModel)]="payoutTransaction.Status">
                                    </p-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-scrollPanel>

        <hr class="driver-line" style="margin-left: -1rem; margin-right: -1rem;" />

        <div class="flex justify-content-end" *ngIf="!showEditFields">
            <div>
                <button pButton pRipple type="button" label="Edit" (click)="showEditFields = true" class="p-button btn-driver-edit"></button>
            </div>
        </div>

        <div class="flex justify-content-end" *ngIf="showEditFields">
            <div>
                <button pButton pRipple type="button" label="Save" class="p-button btn-driver-edit" (click)="updatePayoutTransaction()"></button>
            </div>
        </div>
    </div>

</p-sidebar>

<driver-detail [_visibleDetail]="visibleDriverDetail"
               [_driverId]="payoutTransaction.RiderId"
               (changedVisibleDetailEmit)="changedVisibleDriverDetailEmit($event)"
               *ngIf="visibleDriverDetail"></driver-detail>